import React, { forwardRef, useState } from 'react'
import PropTypes from 'prop-types'
import PhoneInput, { isPossiblePhoneNumber } from 'react-phone-number-input'

import { analytics, form } from 'helpers'
import { BASE_INPUT } from '../styles'
import useVerifyPhoneNumber from '../useVerifyPhoneNumber'

import { InputErrorMessage } from 'components'
import Form from 'components/AuthModal/components/Form'
import CloseButton from 'components/AuthModal/components/CloseButton'
import Button from 'components/AuthModal/components/Button'
import PrivacyTerms from 'components/AuthModal/components/PrivacyTerms'

import logo from 'assets/images/logo.gif'

import 'react-phone-number-input/style.css'

const Input = forwardRef((props, ref) => (
  <input
    {...props}
    ref={ref}
    required
    name="myNumber"
    placeholder="My Number"
    className={`text-center ${BASE_INPUT} border-white bg-white bg-opacity-5`}
  />
))

const VerificationModalPhoneNumber = ({ onSubmit, onClose, autoFocus, user }) => {
  const { verify, cleanError, loading, error } = useVerifyPhoneNumber()
  const [phoneNumber, setPhoneNumber] = useState(user.phoneNumber)

  const handleSubmit = async e => {
    if (!form.checkValidity(e)) return
    analytics.segmentTrack('Anonymous Clicked Verify Phone Number', {
      phoneNumber,
    })
    const { target } = e
    const verified = await verify(phoneNumber)
    if (verified) {
      onSubmit(phoneNumber)
    } else {
      target.elements['myNumber'].focus()
    }
  }

  return (
    <Form noValidate onSubmit={handleSubmit}>
      <CloseButton onClose={onClose} />
      <div className="flex flex-col items-center -mt-6 justify-between w-full">
        <img src={logo} alt="logo" className="mx-auto w-20 mb-2" />
        <div className="uppercase max-w-xs mx-auto text-2xl text-center font-ownersWide text-white font-medium mb-12 md:max-w-md">
          members matchmaking universe
        </div>
        <div className="text-xl text-white text-center font-medium font-ownersWide mb-4">
          PHONE NUMBER
        </div>
        <div className="w-full">
          <PhoneInput
            name="phone"
            key={autoFocus}
            autoFocus={false}
            autoComplete="tel"
            defaultCountry="US"
            value={phoneNumber}
            onChange={e => {
              cleanError()
              setPhoneNumber(e)
            }}
            inputComponent={Input}
          />
          {error && (
            <InputErrorMessage className="mt-2 block text-center">{error}</InputErrorMessage>
          )}
        </div>
      </div>
      <div className="w-full flex flex-col items-center -mb-4">
        <Button
          disabled={!isPossiblePhoneNumber(phoneNumber || '')}
          type="submit"
          loading={loading}
          className="text-base w-full"
        >
          Continue
        </Button>
        <PrivacyTerms className="w-72 text-opacity-30 text-sm text-white" />
      </div>
    </Form>
  )
}

VerificationModalPhoneNumber.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  autoFocus: PropTypes.bool,
  user: PropTypes.object,
}

export default VerificationModalPhoneNumber
